import axios from "axios";
import tough from 'tough-cookie';

export const cookieJar = new tough.CookieJar();

// export const api = axios.create({
//     baseURL: process.env.REACT_APP_BASE_URL + '/school-tour-company/rest',
//     jar: cookieJar,
//     withCredentials: true
// })

export const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    jar: cookieJar,
    withCredentials: true
})

export const gpapi = axios.create({
    baseURL: 'https://apis.sandbox.globalpay.com/ucp',
})

export const authipayapi = axios.create({
    baseURL: 'https://prod.emea.api.fiservapps.com/sandbox/ipp/payments-gateway/v2/payments',
})

export const loginapi = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
})

export const paynowreport = axios.create({
    baseURL: process.env.REACT_APP_PAYNOW_REPORT_URL,
})

const errorHandler = (error) => {
   
    const statusCode = error.response?.status;
    
    if(statusCode && statusCode !== 401){
        console.log(error);
    }
    return Promise.reject(error);
}

api.interceptors.response.use(undefined, (error) => {
    return(errorHandler(error));
})

